import $api from "../http";

export default class ContactService {
    static async sendContactMail(data) {
        return $api.post("send-contact-data", data);
    }
}